/**
 * @description Photothéque des médias
 */

/* global $get */

(() => {
	// FUNCTIONS
	const photoToTheSlider = () => {
		document.querySelectorAll('.image-gallery').forEach((blocPhotos) => {
			const galleryId = blocPhotos
				.querySelector('.image-gallery .btn-primary')
				.getAttribute('data-gallery-id');
			const galleryItem = blocPhotos.querySelectorAll(
				'div.image-gallery__section div'
			);
			let i = 0;
			galleryItem.forEach((photos) => {
				if (photos.getAttribute('class') === 'media-image') {
					photos.insertAdjacentHTML(
						'afterbegin',
						`<button data-link-gallery data-media-type="image" data-id="${i}" data-gallery-id="${galleryId}" class="media-button album__item__photo__slider">
							<i data-icon="zoom"></i>
							<span class="sr-only">Carrousel</span>
						</button>`
					);
				} else if (photos.getAttribute('class') === 'media-video') {
					photos.insertAdjacentHTML(
						'afterbegin',
						`<button data-link-gallery data-media-type="video" data-id="${i}" data-gallery-id="${galleryId}" class="media-button player-media-button">
							<i data-icon="videotheque"></i>
							<span class="sr-only">Carrousel</span>
						</button>`
					);
				}
				i++;
			});
		});
	};

	const videoStart = () => {
		document
			.querySelectorAll('.media-video button')
			.forEach((videoButton) => {
				videoButton.addEventListener('click', () => {
					const albumId = videoButton.getAttribute('data-gallery-id');
					const mediaId = videoButton.getAttribute('data-id') - 1;

					$get(`/phototheque/get/${albumId}?isPost=true`).then(
						(data) => {
							const urlTab = [];
							for (let i = 0; i < data.galleryData.length; i++) {
								console.log(data.galleryData);
								urlTab.push(data.galleryData[i].url);
							}
							const urlTabreversed = urlTab.reverse();
							if (
								document.querySelector('.over-player-video') ===
								null
							) {
								window.scroll({
									top: 0,
									left: 0,
									behavior: 'smooth',
								});
								document
									.querySelector('body')
									.classList.add('overflow-layout');
								document
									.querySelector('body')
									.insertAdjacentHTML(
										'afterbegin',
										`<div class="over-player-video">
                          				<button class="over-player-video__close"><i data-icon="arrow"></i></button>
                          				<iframe src="${urlTabreversed[mediaId]}"</iframe>
                        				</div>`
									);
							}

							document
								.querySelector(
									'.over-player-video .over-player-video__close'
								)
								.addEventListener('click', () => {
									document
										.querySelector('.over-player-video')
										.classList.add('slideDown');
									setTimeout(() => {
										document
											.querySelector('.over-player-video')
											.remove();
									}, 800);
									document
										.querySelector('body')
										.classList.remove('overflow-layout');
								});
						}
					);
				});
			});
	};

	// GO 🚀
	const init = () => {
		photoToTheSlider();
		videoStart();
	};

	init();
})();
